import { render, staticRenderFns } from "./BoardRegister.vue?vue&type=template&id=2c1446b9&scoped=true"
import script from "./BoardRegister.vue?vue&type=script&lang=js"
export * from "./BoardRegister.vue?vue&type=script&lang=js"
import style0 from "./BoardRegister.vue?vue&type=style&index=0&id=2c1446b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1446b9",
  null
  
)

export default component.exports